import * as React from 'react';

import { useQuery } from '@apollo/client';
import {
  PerceptionModelJobsQuery,
  type PerceptionModelJobOption,
} from '@graphql/queries/PerceptionModelQueries';

/**
 * The perception model versions worth offering.
 *
 * A run only becomes selectable once it has exported products: until then there
 * are no peer lists and no coordinates, so it can neither be explored nor
 * anchored against. Ordered newest first by the query, so `models[0]` is the
 * latest usable version.
 */
const usePerceptionModels = () => {
  const { data, loading, error } = useQuery(PerceptionModelJobsQuery);

  const allJobs: PerceptionModelJobOption[] =
    data?.allPerceptionModelJobs?.nodes ?? [];

  const models = React.useMemo(
    () =>
      allJobs.filter(
        (j) =>
          (j.perceptionModelProductLookupsByPerceptionModelJobId?.totalCount ??
            0) > 0,
      ),
    [allJobs],
  );

  return { allJobs, models, loading, error };
};

export default usePerceptionModels;
